module.exports = __webpack_public_path__ + "static/media/website-14.acd53298.png";